import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { ContentCafeProvider } from '../../providers/content-cafe/content-cafe';
import { BibItem, ItemProvider } from '../../providers/item/item';
import { PopoverController, LoadingController, Platform } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { AppState } from '../../config/state';
import { PatronProvider } from '../../providers/patron/patron';
import { IlsProvider } from '../../providers/ils/ils';
import { MailProvider } from '../../providers/mail/mail';
import { LocationsProvider } from '../../providers/locations/locations';
import { LoginProvider } from '../../providers/login/login';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DigitalItemsProvider } from '../../providers/digital-items/digital-items';

/**
 * Generated class for the CoDigitalItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-digital-item',
  templateUrl: 'co-digital-item.html'
})
export class CoDigitalItemComponent {
  public updateObserver: Subject<Array<number>>;
  detailView: any = 'Overview';
  @Input() novelistDetails: any;
  @Input() bibDetails: BibItem;
  @Input() style: string;
  @Input() previousItems: Array<any>;
  reviews: Array<any> = [];
  annotations: Array<any> = [];
  extras: Array<any> = [];
  description: string = "";
  rating: number = null;
  patron: any;
  holdLocationsList: Array<any> = [];
  updateTimer: any;
  // private itemDetails: any = {};
  currentModal: any;
  similarTitleReason: string;
  lastItemViewedTitle: string;
  contentContainer: any;
  checkoutButton: string;
  itemSrc: string;
  secondaryActionButton: string;
  secondaryButton: boolean;
  checkingOverdriveAvailability: boolean;
  itemAvailability: any;
  @Output() addItemToList = new EventEmitter<any>();
  @ViewChild('contentContainer') contentContainerViewChild;
  constructor(private bib: CoBibItemProvider, private contentcafe: ContentCafeProvider, private popoverCtrl: PopoverController, private toast: ToastAlertsProvider, private state: AppState, public loading: LoadingController, private patronProvider: PatronProvider, private email: MailProvider, private loginProvider: LoginProvider, private platform: Platform, private inAppBrowser: InAppBrowser, private digitalProvider : DigitalItemsProvider, private alerts : ToastAlertsProvider) {
  }

  async showItem(isbn) { //maybe dont need this
    let bookDetails = await this.bib.getParamsFromISBN(isbn);
    this.novelistDetails = bookDetails.novelistDetails;
    this.bibDetails = bookDetails.bibDetails;
    this.initializeBook();
    this.contentContainer = this.contentContainerViewChild.nativeElement.parentElement.parentElement;
    this.contentContainer.scroll(0, 0);
  }
  public update() {
    this.updateObserver.next();
  }
  ngOnDestroy() {
    if (this.updateTimer) clearInterval(this.updateTimer);
  }
  ngOnInit(): void {
    this.initializeBook();
  }

  initializeBook() {
    this.addItemToList.emit({bibDetails: this.bibDetails, novelistDetails: this.novelistDetails || null});
    this.itemSrc = this.bibDetails.source;
    this.annotations = [];
    this.reviews = [];
    this.extras = [];
    this.updateTimer = setInterval(() => this.update(), 500);

    switch(this.itemSrc){
      case 'hoopla':
        this.checkoutButton = "Checkout";
        this.secondaryButton = true;
        this.secondaryActionButton = "View in Hoopla";
      break;
      case 'overdrive':
        this.secondaryButton = false;
        this.getOverdriveAvailability();
      break;
    }


    if (!this.bibDetails && this.novelistDetails) {//we dont have bibDetails, lets make a fake one from the novelistData
      this.bibDetails = {
        id: null,
        title: this.novelistDetails.title || "",
        author: this.novelistDetails.author || "",
        available: null,
        format: "",
        publishYear: null,
        isbns: [],
        series: [],
        subjects: [],
        summaries: [], //{text,source}
        notes: [],
      }
    }
    this.updateObserver = new Subject();
    if (this.bibDetails) {
      this.mergeBibDetails(this.bibDetails);
    }

    if (this.novelistDetails) {
      this.rating = this.novelistDetails.rating;
      this.bibDetails.isbns.unshift(this.novelistDetails.primaryISBN);
      if (this.novelistDetails.description) {
        this.description = this.novelistDetails.description;
        this.annotations.push({ text: this.novelistDetails.description, source: 'Novelist' })
      }
      if (this.novelistDetails.seriesInfo) {
        this.novelistDetails.seriesInfo.seriesItems = this.novelistDetails.seriesInfo.seriesItems.map(i => this.loadCover(i));
      }
      if (this.novelistDetails.similarTitles) {
        this.novelistDetails.similarTitles = this.novelistDetails.similarTitles.map(i => this.loadCover(i));
      }
    }

    if (this.bibDetails && this.bibDetails.isbns && this.bibDetails.isbns.length > 0) {
      this.contentcafe.reviews(this.bibDetails.isbns[0]).then(reviews => {
        if (reviews) {
          this.reviews = this.reviews.concat(reviews);
        }
      });
      this.contentcafe.annotations(this.bibDetails.isbns[0]).then(annotations => {
        if (annotations) {
          this.annotations = this.annotations.concat(annotations);

        }
      });
    }
    this.patron = this.state.patron;
    // if (this.annotations.length <= 0 && this.bibDetails.summaries && this.bibDetails.summaries[0]){
    //   this.bibDetails.summaries[0].forEach(s=>this.annotations.push(s));
    // }
    if (this.annotations.length > 0){
      this.annotations = this.annotations.filter((annotation, index, self) => index === self.findIndex((t) => (t === annotation)))
    }

    if(this.bibDetails && this.bibDetails.summaries) {
      this.annotations.concat(this.bibDetails.summaries);
    }

    if (this.reviews.length <= 0) this.reviews = this.bibDetails.reviews || [];
    if (this.previousItems.length > 1 && this.bibDetails){ // Checks last book for reasoning behind why similar item
      if(this.previousItems[this.previousItems.length-2].novelistDetails && this.previousItems[this.previousItems.length-2].novelistDetails.similarTitles){
        let book = this.previousItems[this.previousItems.length-2].novelistDetails.similarTitles.filter(item =>{
          return (this.bibDetails.isbns.join(',').includes(item.primaryISBN))
        });
        if (book[0] && book[0].reason){
         this.similarTitleReason = book[0].reason;
         this.lastItemViewedTitle = this.previousItems[this.previousItems.length-2].bibDetails.title;
        }
      }
    }
  }

  getOverdriveAvailability() {
    this.checkingOverdriveAvailability = true;
    let id:any = this.bibDetails.id;
    if(this.bibDetails.ids && this.bibDetails.ids.length > 0) {
      let overdriveId = this.bibDetails.ids.find( id => id.type.toLowerCase() === 'overdrive' );
      if(overdriveId) id = overdriveId.id;
    }
    this.digitalProvider.getOverdriveItemAvailability(id).then( (availability) => {
      this.itemAvailability = availability;
      this.checkingOverdriveAvailability = false;
      if(availability.available) this.checkoutButton = 'Checkout';
      else this.checkoutButton = 'Place hold';
    }).catch( () => { this.checkingOverdriveAvailability = false; });
  }

  mergeBibDetails(bib) {
    if (bib.summaries && bib.summaries.length > 0 && bib.summaries[0]) {
      if(bib.summaries[0].text) {
        this.description = bib.summaries[0].text;
      } else {
        this.description = bib.summaries[0];
      }
      this.annotations = this.annotations.concat(bib.summaries.flat());
    }
    if (bib.format) this.extras.push({ name: 'Format', value: bib.format });
    if (bib.publishYear) this.extras.push({ name: 'Year', value: bib.publishYear });
    if (bib.subjects) this.extras.push(...bib.subjects.map(s => { return { name: 'Subject', value: s.value || s } }));
    if (bib.series) this.extras.push(...bib.series.map(s => { return { name: 'Series', value: s.value || s } }));
    if (bib.notes) this.extras.push(...bib.notes.map(s => { return { name: 'Note', value: s.value || s } }));
    if (bib.ids) {
      this.extras.push(...bib.ids.map(id => { return { name: id.type, value: id.id } }));
    } else {
      if (bib.isbns) this.extras.push(...bib.isbns.map(s => { return { name: 'ISBN', value: s.value || s } }));
      if (bib.upcs) this.extras.push(...bib.upcs.map(s => { return { name: 'UPC', value: s.value || s } }));
    }
    if (bib.authors) this.extras.push(...bib.authors.map(s => { return { name: 'Author', value: s.value || s } }));
    if (bib.pageCount) this.extras.push({ name: 'Pages', value: bib.pageCount });
    if (bib.language) this.extras.push({ name: 'Language', value: bib.language[0] || bib.language });
    if (bib.averageRating && this.rating) this.rating = bib.averageRating;
    // console.log(this.extras);
    this.extras = this.extras.filter((extra, index, self) => index === self.findIndex((t) => (t.value === extra.value)));
  }

  emailBookInfo(item) {
    let customClass = 'custom-email-input-popover';
    let popover = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email' }, { cssClass: customClass });
    popover.present({ ev: '' });

    popover.onDidDismiss(email => {
      if (email && email.info) {
        let available;
        this.bibDetails.available? available = "YES" : available = "NONE AVAILABLE";
        let emails = [];
        emails.push({ email: email.info })
        let params = {email: email.info, template: "item_scan_information", phone: ''}
        let vars = {
          title: this.bibDetails.title,
          author: this.bibDetails.author,
          barcode: this.bibDetails.barcode || 'none',
          isbn: this.bibDetails.isbns[0] || 'none',
          upc: this.bibDetails.upcs[0] || 'none',
          available: available,
          description: this.description
        }
        this.email.sendItemInfoEmail(params, vars);
        this.toast.showAlert('',`Details for '${this.bibDetails.title}' sent to ${email.info}!`,'success');
      }
    })
  }

  placeHold() {
    this.loginProvider.requireLogin((res) => {
      this.patron = res;
      if (this.patron && this.patron.id) {
        let loader = this.loading.create({content: 'Placing hold...'});
        loader.present();
        let id:any = this.bibDetails.id;
        if(this.bibDetails.ids && this.bibDetails.ids.length > 0) {
          let overdriveId = this.bibDetails.ids.find( id => id.type.toLowerCase() === 'overdrive' );
          if(overdriveId) id = overdriveId.id;
        }
        this.digitalProvider.overdrivePlaceHold(id, this.patron.barcode, this.patron.pin, this.patron.email).then( (res) => {
          loader.dismiss().catch(err=>{});
          if(res.status) {
            this.alerts.showAlert('', 'Request successful, you will be notified when this title is available to borrow.', 'success', 5000);
          } else {
            this.alerts.showAlert('', res.message ? res.message : 'Sorry, there was a problem checking out this item', '', 5000);
          }
        }).catch( (e) => {
          loader.dismiss().catch(err=>{});
          this.alerts.showAlert('', 'Sorry, there was a problem checking out this item', '', 5000);
        });
      }
    });
  }

  primaryDigitalAction() {
    if(this.checkoutButton === 'Checkout') this.checkoutDigitalItem();
    else this.placeHold();
  }

  checkoutDigitalItem(){
    this.loginProvider.requireLogin((res) => {
      this.patron = res;
      if (this.patron && this.patron.id) {
        let loader = this.loading.create({content: 'Checking out item...'});
        loader.present();
            // console.log(id)
            this.digitalProvider.checkoutDigitalItem(this.itemSrc, this.bibDetails, this.patron.barcode, this.patron.pin).then(res =>{
              loader.dismiss().catch(err=>{});
              // console.log(res);
              if (res && (res.status)) {
                this.alerts.showAlert('', 'Your item has been checked out and can be accessed from your account.', 'success', 5000);
                if(this.itemSrc === 'overdrive') {
                  this.secondaryActionButton = 'Read now';
                  this.secondaryButton = true;
                }
              } else if (res && res.message){
                this.alerts.showAlert('', res.message, '', 5000);
              } else {
                this.alerts.showAlert('', 'Sorry, there was a problem checking out this item', '', 5000);
              }
            });
      }
    });
  }

  secondaryDigitalAction(){
    switch(this.itemSrc){
      case 'hoopla':
        let hooplaId = this.bibDetails.id.toString().replace(/\D/g,'');
        this.inAppBrowser.create(`https://www.hoopladigital.com/title/${hooplaId}`, '_system');
      break;
      case 'overdrive':
        this.digitalProvider.readNow('overdrive', this.bibDetails, this.patron.barcode, this.patron.pin);
    }
  }

  titleCase(str) {
    return str.toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ');
  }

  loadCover(i) { //WILL HAVE TO ADD INFO ABOUT COVER HERE
    const server = Math.floor(Math.random() * 9);
    i.cover = `https://${this.state.client.keyword}.libnet.info/getcover/${i.primaryISBN}`;
    // i.cover = `http://covers${server}.communico.co/isbn/o/${i.primaryISBN}.jpg`;
    i.error = `http://covers${server}.communico.co/gen/cover?title=` + encodeURIComponent(i.title);
    return i;
  }

}



// WEBPACK FOOTER //
// ./src/components/co-digital-item/co-digital-item.ts